import './styles.scss';

export const AbsoluteLoader = () => {
  return (
    <div className="absolute-loader">
      <div className="spinner" />
    </div>
  );
};
